<template>
    <div
        class="text-xs text-gray-700 "
        :class="{ 'fade-out-text': !visible }"
    >
        {{ content }}

        <button
            v-show="!visible"
            type="button"
            class="reveal-btn"
            @click="visible = ! visible"
        >
            <span class="inline-block relative">
                <span class="absolute -inset-1 bg-white rounded-lg blur" />
                <span class="relative bg-white rounded-full py-xs px-xl text-xs text-green-500 hover:text-green-600">Visa allt</span>
            </span>
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            content: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                visible: this.content.length < 160,
            };
        },
    };
</script>
